import request from '@/utils/request'


//查询课程卡
export function qlLessonTemplate(params) {
  return request({
    url: '/admin/storelesson/qlLessonTemplate',
    method: 'get',
    params: params
  })
}

//查询门店可用的业务类型
export function selectValidLessonTemplate(params) {
  return request({
    url: '/admin/storelesson/selectValidLessonTemplate',
    method: 'get',
    params: params
  })
}

export function queryListUserBuyCardByUserIdGETY(params) {
  return request({
    url: '/admin/bycard/queryListUserBuyCardByUserId',
    method: 'get',
    params: params
  })
}






// WEBPACK FOOTER //
// ./src/api/StoreLesson.js